<template>
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <!-- Badge -->
        <div :class="badgeClasses" class="px-6 py-2 border-b" data-test="invoice-badge">
            <span :class="badgeTextClasses" class="text-xs font-medium uppercase tracking-wider" data-test="badge-text">
                {{ badgeText }}
            </span>
        </div>

        <!-- Content -->
        <div class="p-6">
            <div class="mb-6">
                <div class="flex items-start justify-between">
                    <div>
                        <h3 class="text-lg font-semibold text-gray-900">
                            {{ monthYear }}
                        </h3>
                        <p class="text-sm text-gray-500 mt-2">
                            {{ timingText }}
                        </p>
                    </div>
                    <div class="text-right">
                        <div class="text-xs text-gray-500 mb-1">Estimated total</div>
                        <div class="text-2xl font-bold text-gray-900">
                            {{ formattedTotal }}
                        </div>
                        <div class="text-xs text-gray-500 mt-1">
                            {{ paymentTermsText }}
                        </div>
                    </div>
                </div>
            </div>
            <invoice-line-items :totalCents="invoice.total_cents" :lineItems="invoice.line_items" />
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import InvoiceLineItems from './InvoiceLineItems.vue';
import { currencyCents } from '~/utils/helpers';
import { useBillingDates } from '~/composables/useBillingDates';

const props = defineProps({
    invoice: {
        type: Object,
        required: true,
    },
    invoiceDate: {
        type: String,
        required: true,
    },
    type: {
        type: String,
        required: true,
        validator: (value) => ['previous', 'current'].includes(value),
    },
    paymentTermsText: {
        type: String,
        required: true,
    },
});

const { formatMonthYear, getInvoiceSendDate } = useBillingDates();

const badgeText = computed(() => {
    return props.type === 'previous' ? 'Previous Month Estimate' : 'Month in Progress';
});

const badgeClasses = computed(() => {
    return props.type === 'previous' ? 'bg-gray-50 border-gray-200' : 'bg-blue-50 border-blue-200';
});

const badgeTextClasses = computed(() => {
    return props.type === 'previous' ? 'text-gray-600' : 'text-blue-700';
});

const monthYear = computed(() => {
    return formatMonthYear(props.invoiceDate);
});

const timingText = computed(() => {
    return `Invoice will be sent ${getInvoiceSendDate(props.invoiceDate)}`;
});

const formattedTotal = computed(() => {
    return currencyCents(props.invoice.total_cents);
});
</script>
